// extracted by mini-css-extract-plugin
export var background = "Layout-module--background--b50a9";
export var backgroundBottom = "Layout-module--background-bottom--ffaef";
export var backgroundHome = "Layout-module--background-home--df7fd";
export var base = "Layout-module--base--7e53a";
export var blackDivider = "Layout-module--black-divider--b8c1c";
export var content = "Layout-module--content--6ac40";
export var footer = "Layout-module--footer--ca722";
export var greenDivider = "Layout-module--green-divider--80342";
export var hide = "Layout-module--hide--be880";
export var sidebar = "Layout-module--sidebar--b975d";